<template>
  <div class="step-three">
    <div v-show="type == 1" class="person">
      <el-form ref="personForm" :model="personForm" :rules="personFormRules" size="small" label-width="120px" label-position="left">
        <el-form-item label="支付宝收款人" prop="alipayPayee">
          <el-input v-model="personForm.alipayPayee" maxlength="30" placeholder="请输入支付宝收款人"></el-input>
        </el-form-item>
        <el-form-item label="支付宝账户" prop="alipayAccount">
          <el-input v-model="personForm.alipayAccount" maxlength="30" placeholder="请输入支付宝账户"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div v-show="type == 2" class="person">
      <el-form ref="companyForm" :model="companyForm" :rules="companyFormRules" size="small" label-width="120px" label-position="left">
        <el-form-item label="支付宝收款人" prop="alipayPayee">
          <el-input v-model="companyForm.alipayPayee" maxlength="30" placeholder="请输入支付宝收款人"></el-input>
        </el-form-item>
        <el-form-item label="支付宝账户" prop="alipayAccount">
          <el-input v-model="companyForm.alipayAccount" maxlength="30" placeholder="请输入支付宝账户"></el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'step-three',
  props: {
    type: {
      type: String
    }
  },
  data() {
    return {
      personForm: {
        alipayPayee: '',
        alipayAccount: '',
      },
      personFormRules: {
        alipayPayee: [{ required: true, message: '请输入支付宝收款人', trigger: 'blur' }],
        alipayAccount: [{ required: true, message: '请输入支付宝账户', trigger: 'blur' }],
      },
      companyForm: {
        alipayPayee: '',
        alipayAccount: '',
        accountNo: ''
      },
      companyFormRules: {
        alipayPayee: [{ required: true, message: '请输入支付宝收款人', trigger: 'blur' }],
        alipayAccount: [{ required: true, message: '请输入支付宝账户', trigger: 'blur' }],
      },
    }
  },
  mounted() {},
  methods: {
    getValidate() {
      return this.type == 1 ? this.$refs.personForm.validate() : this.$refs.companyForm.validate()
    },
    getFormData() {
      return { formDataThree: this.type === '1' ? this.personForm : this.companyForm }
    }
  }
}
</script>

<style lang="less" scoped>
.step-three {
  .info {
    line-height: 20px;
    margin-bottom:30px;
    color: #E6A23C;
  }
  .proto {
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/producerRegister/StepThree.vue